export default __webpack_public_path__ + "static/media/2017 (1).1f10b9c0.jpg";